export const networkMap = {
  sol: 'Solana',
  divi: 'Divi',
  eth: 'Ethereum',
  bsc: 'BNB Chain',
  ethw: 'EthereumPoW',
  trx: 'Tron',
  matic: 'Polygon',
  cchain: 'C-Chain',
  xdc: 'XDC Network',
  klay: 'Klaytn',
  near: 'Near',
  atom: 'Atom',
  iota: 'IOTA',
  theta: 'Theta',
  iotx: 'IOTX',
  luna: 'LUNA',
  lunc: 'LUNC',
  btc: 'Bitcoin',
  xchain: 'X-Chain',
  ftm: 'Fantom',
  xym: 'XYM',
  one: 'Onion',
  xem: 'XEM',
  etc: 'Ethereum Classic',
  nano: 'Nano',
  beam: 'Beam',
  kmd: 'Komodo',
  qtum: 'QTUM',
  bcd: 'BCD',
  dcr: 'Decred',
  firo: 'Firo',
  neo: 'NEO',
  xmr: 'XMR',
  ada: 'ADA',
  xrp: 'XRP',
  waves: 'Waves',
  zil: 'Zilliqa',
  dash: 'Dash',
  xlm: 'XLM',
  bnb: 'BNB Chain',
  btg: 'Bitcoin Gold',
  algo: 'Algorand',
  dot: 'Polkadot',
  grs: 'Grails',
  lsk: 'Lisk',
  ont: 'Ontology',
  eos: 'EOS',
  hbar: 'Hbar',
  ark: 'Ark',
  doge: 'Dogecoin',
  egld: 'EGLD',
  fil: 'Filecoin',
  rvn: 'Ravencoin',
  sxp: 'SXP',
  ton: 'TON',
  xtz: 'Tezos',
  zen: 'Zen',
  dgb: 'Digibyte',
  zec: 'Zecoin',
  xvg: 'Verge',
  bch: 'Bitcoin Cash',
  ltc: 'Litecoin',
  icx: 'ICON',
  strax: 'STRAX',
  sui: 'SUI',
};


export const baseQuickAmounts = [5, 10, 20, 30, 50, 100];


export const supportedCurrencies = [
  "USDDTRC20",
  "USDCSOL",
  "USDTMATIC",
  "TUSD",
  "USDCXLM",
  "USDCMATIC",
  "USDDBSC",
  "BUSDMATIC",
  "USDCBSC",
  "BEAM",
  "DAI",
  "USDTSOL",
  "TUSDTRC20",
  "FIRO",
  "USDTERC20",
  "USDP",
  "USDC",
  "USDTBSC",
  "USDTTRC20",
  "BTC",
  "ETH",
  "LTC",
  "BCH",
  "TRX",
  "DOGE",
  "LINK",
  "TON",
  "SUI"
]